var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messenger"},[_c('People',{staticClass:"people",class:{ hidden: !_vm.inMenu }}),_c('ChatBody',{staticClass:"chat-body",class:{ hidden: _vm.inMenu },attrs:{"chat-from-router":_vm.chatFromRouter,"visible":!_vm.inMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }